// Path: packages/app/src/helpers/url.ts
export const createUrl = (suffix: string) => {
    const url = new URL(suffix, window.location.href);
    return url.toString();
};

export const baseHostname = () => window.location.host;
